/* eslint-disable */
export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.texts = {};
    Blockly.Blocks.texts.style = 'text_blocks';
    Blockly.Msg.TEXTS_HUE = 160;
    Blockly.Blocks.text = {
        init: function() {
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.texts.style);
            this.appendDummyInput()
                .appendField(new Blockly.FieldImage(img_path + "arduino/quotation_mark_1.svg", 25, 25))
                .appendField(new Blockly.FieldTextInput(""), "TEXT")
                .appendField(new Blockly.FieldImage(img_path + "arduino/quotation_mark_2.svg", 25, 25));
            this.setOutput(!0, "String");
            this.setTooltip(Blockly.Msg.TEXT_TEXT_TOOLTIP)
        },
    };
    Blockly.Blocks.text_tonumber = {
        init: function() {
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.texts.style);
            this.appendDummyInput().appendField(Blockly.Msg.TEXT_TONUMBER);
            this.appendValueInput("TXT").setCheck("String");
            this.setInputsInline(!0);
            this.setOutput(!0, "Number")
        }
    };
    Blockly.Blocks.text_format = {
        init: function() {
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.texts.style);
            this.appendDummyInput().appendField(Blockly.Msg.TEXT_FORMAT);
            this.appendValueInput("NUM").setCheck("Number");
            this.appendDummyInput().appendField(Blockly.Msg.TEXT_AS).appendField(new Blockly.FieldDropdown([
                ["HEX", "HEX"],
                ["BIN", "BIN"],
                ["DEC", "DEC"]
            ]), "FORMAT");
            this.setInputsInline(!0);
            this.setOutput(!0, "String")
        }
    };
    Blockly.Blocks.text_format_decimal = {
        init: function() {
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.texts.style);
            this.appendDummyInput().appendField(Blockly.Msg.TEXT_FORMAT);
            this.appendValueInput("NUM").setCheck("Number");
            this.appendDummyInput().appendField(Blockly.Msg.TEXT_WITH).appendField(new Blockly.FieldDropdown([
                ["0", "0"],
                ["1", "1"],
                ["2", "2"],
                ["3", "3"],
                ["4", "4"],
                ["5", "5"],
                ["6", "6"]
            ]), "DECIMALS").appendField(Blockly.Msg.TEXT_DECIMAL);
            this.setInputsInline(!0);
            this.setOutput(!0,
                "String")
        }
    };
    // This arduino text_join block is overrided by plus minus plugin
    Blockly.Blocks.text_join = {
        init: function() {
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.texts.style);
            this.itemCount_ = 2;
            this.updateShape_();
            this.setOutput(!0, "String");
            this.setMutator(new Blockly.Mutator(["text_create_join_item"]));
            this.setTooltip(Blockly.Msg.TEXT_JOIN_TOOLTIP)
        },
        mutationToDom: function() {
            var a = document.createElement("mutation");
            a.setAttribute("items", this.itemCount_);
            return a
        },
        domToMutation: function(a) {
            this.itemCount_ = parseInt(a.getAttribute("items"), 10);
            this.updateShape_()
        },
        decompose: function(a) {
            var b = a.newBlock("text_create_join_container");
            b.initSvg();
            for (var c = b.getInput("STACK").connection, d = 0; d < this.itemCount_; d++) {
                var e = a.newBlock("text_create_join_item");
                e.initSvg();
                c.connect(e.previousConnection);
                c = e.nextConnection
            }
            return b
        },
        compose: function(a) {
            var b = a.getInputTargetBlock("STACK");
            for (a = []; b;) a.push(b.valueConnection_), b = b.nextConnection && b.nextConnection.targetBlock();
            this.itemCount_ = a.length;
            this.updateShape_();
            for (b = 0; b < this.itemCount_; b++) a[b] &&
                this.getInput("ADD" + b).connection.connect(a[b])
        },
        saveConnections: function(a) {
            a = a.getInputTargetBlock("STACK");
            for (var b = 0; a;) {
                var c = this.getInput("ADD" + b);
                a.valueConnection_ = c && c.connection.targetConnection;
                b++;
                a = a.nextConnection && a.nextConnection.targetBlock()
            }
        },
        updateShape_: function() {
            if (this.getInput("EMPTY")) this.removeInput("EMPTY");
            else
                for (var a = 0; this.getInput("ADD" + a);) this.removeInput("ADD" + a), a++;
            if (0 == this.itemCount_) this.appendDummyInput("EMPTY").appendField(this.newQuote_(!0)).appendField(this.newQuote_(!1));
            else
                for (a = 0; a < this.itemCount_; a++) {
                    var b = this.appendValueInput("ADD" + a);
                    0 == a && b.appendField(Blockly.Msg.TEXT_JOIN_TITLE_CREATEWITH)
                }
        },
        newQuote_: Blockly.Blocks.text.newQuote_
    };
    Blockly.Blocks.text_create_join_container = {
        init: function() {
            this.setStyle(Blockly.Blocks.texts.style);
            this.appendDummyInput().appendField(Blockly.Msg.TEXT_CREATE_JOIN_TITLE_JOIN);
            this.appendStatementInput("STACK");
            this.setTooltip(Blockly.Msg.TEXT_CREATE_JOIN_TOOLTIP);
            this.contextMenu = !1
        }
    };
    Blockly.Blocks.text_create_join_item = {
        init: function() {
            this.setStyle(Blockly.Blocks.texts.style);
            this.appendDummyInput().appendField(Blockly.Msg.TEXT_CREATE_JOIN_ITEM_TITLE_ITEM);
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.setTooltip(Blockly.Msg.TEXT_CREATE_JOIN_ITEM_TOOLTIP);
            this.contextMenu = !1
        }
    };
    Blockly.Blocks.text_length = {
        init: function() {
            this.jsonInit({
                message0: Blockly.Msg.TEXT_LENGTH_TITLE,
                args0: [{
                    type: "input_value",
                    name: "VALUE",
                    check: ["String", "Array"]
                }],
                output: "Number",
                style: Blockly.Blocks.texts.style,
                tooltip: Blockly.Msg.TEXT_LENGTH_TOOLTIP,
                helpUrl: ""
            })
        }
    };
    Blockly.Blocks.text_compare = {
        init: function() {
            this.setStyle(Blockly.Blocks.texts.style);
            this.appendValueInput("TEXT1", "String");
            this.appendDummyInput().appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.TEXT_EQUALS, "equals"],
                [Blockly.Msg.TEXT_EQUALS_IGNORE, "equalsignore"],
                [Blockly.Msg.TEXT_NOT_EQUALS, "notequals"],
                [Blockly.Msg.TEXT_STARTSWITH, "startswith"],
                [Blockly.Msg.TEXT_ENDSWITH, "endswith"]
            ]), "TYPE");
            this.appendValueInput("TEXT2", "String");
            this.setInputsInline(!0);
            this.setOutput(!0, "Boolean")
        }
    };
    Blockly.Blocks.text_indexof = {
        init: function() {
            this.setStyle(Blockly.Blocks.texts.style);
            this.appendValueInput("TEXT1", "String")
                .setCheck("String")
                .appendField(Blockly.Msg.TEXT_INDEXOF);
            this.appendValueInput("TEXT2", "String")
                .setCheck("String")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.TEXT_INDEXOF_1);
            this.appendDummyInput()
                .appendField(new Blockly.FieldDropdown([
                  [Blockly.Msg.TEXT_INDEXOF_FIRST, "indexof"],
                  [Blockly.Msg.TEXT_INDEXOF_LAST, "lastindexof"]
                ]), "TYPE")
                .setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(!1);
            this.setOutput(!0, "Number")
        }
    };
    Blockly.Blocks.text_contains = {
        init: function() {
            this.setStyle(Blockly.Blocks.texts.style);
            this.appendValueInput("TEXT1", "String")
                .setCheck("String")
                .appendField(Blockly.Msg.TEXT_CONTAINS);
            this.appendValueInput("TEXT2", "String")
                .setCheck("String")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.TEXT_CONTAINS_1);
            this.setInputsInline(!1);
            this.setOutput(!0, "Boolean")
        }
    };
    Blockly.Blocks.text_replace = {
        init: function() {
            this.setHelpUrl('');
            this.setStyle(Blockly.Blocks.texts.style);
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.TEXT_REPLACE)
                .appendField(new Blockly.FieldVariable(Blockly.Msg.VARIABLES_DEFAULT_NAME_TEXT, null, ['String'], 'String'), "VARTEXT");
            this.appendValueInput("TEXT2", "String")
                .setCheck("String")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.TEXT_REPLACE_1);
            this.appendValueInput("TEXT3", "String")
                .setCheck("String")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.TEXT_REPLACE_2);
            this.setInputsInline(!1);
            this.setOutput(!1)
        }
    };
    Blockly.Blocks.text_substring = {
        init: function() {
            this.setStyle(Blockly.Blocks.texts.style);
            this.appendValueInput("TEXT1", "String").setCheck("String").appendField(Blockly.Msg.TEXT_SUBSTRING);
            this.appendValueInput("START").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.TEXT_SUBSTRING_1);
            this.appendValueInput("END").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.TEXT_SUBSTRING_2);
            this.setInputsInline(!1);
            this.setOutput(!0, "String")
        }
    };
    Blockly.Blocks.text_ascii = {
        init: function() {
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.texts.style);
            this.appendDummyInput().appendField(Blockly.Msg.TEXT_ASCII).appendField(new Blockly.FieldDropdown([
                ["a", "a"],
                ["b", "b"],
                ["c", "c"],
                ["d", "d"],
                ["e", "e"],
                ["f", "f"],
                ["g", "g"],
                ["h", "h"],
                ["i", "i"],
                ["j", "j"],
                ["k", "k"],
                ["l", "l"],
                ["m", "m"],
                ["n", "n"],
                ["o", "o"],
                ["p", "p"],
                ["q", "q"],
                ["r", "r"],
                ["s", "s"],
                ["t", "t"],
                ["u", "u"],
                ["v", "v"],
                ["w", "w"],
                ["x", "x"],
                ["y", "y"],
                ["z", "z"],
                ["A", "A"],
                ["B", "B"],
                ["C", "C"],
                ["D", "D"],
                ["E", "E"],
                ["F", "F"],
                ["G", "G"],
                ["H", "H"],
                ["I", "I"],
                ["J", "J"],
                ["K", "K"],
                ["L", "L"],
                ["M", "M"],
                ["N", "N"],
                ["O", "O"],
                ["P", "P"],
                ["Q", "Q"],
                ["R", "R"],
                ["S", "S"],
                ["T", "T"],
                ["U", "U"],
                ["V", "V"],
                ["W", "W"],
                ["X", "X"],
                ["Y", "Y"],
                ["Z", "Z"],
                ["0", "0"],
                ["1", "1"],
                ["2", "2"],
                ["3", "3"],
                ["4", "4"],
                ["5", "5"],
                ["6", "6"],
                ["7", "7"],
                ["8", "8"],
                ["9", "9"],
                ["!", "!"],
                ['"', '"'],
                ["#", "#"],
                ["$", "$"],
                ["%", "%"],
                ["&", "&"],
                ["(", "("],
                [")", ")"],
                ["*", "*"],
                ["+", "+"],
                ["-", "-"],
                [".", "."],
                ["/", "/"],
                ["{", "}"],
                ["|", "|"],
                ["\\", "\\"],
                ["[", "["],
                ["@", "@"],
                ["]", "]"],
                ["^", "^"],
                ["_", "_"],
                [":", ":"],
                [";", ";"],
                [",", ","],
                ["<", "<"],
                [">", ">"],
                ["?", "?"],
                ["space", " "]
            ]), "CHAR");
            this.setInputsInline(!0);
            this.setOutput(!0, "Number")
        }
    };
}